import { render, staticRenderFns } from "./UgTableHeaderRow.vue?vue&type=template&id=c8478808&scoped=true"
import script from "./UgTableHeaderRow.vue?vue&type=script&lang=ts"
export * from "./UgTableHeaderRow.vue?vue&type=script&lang=ts"
import style0 from "./UgTableHeaderRow.vue?vue&type=style&index=0&id=c8478808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8478808",
  null
  
)

export default component.exports